module.exports = __webpack_public_path__ + "img/d4.209cc37b.png";